<template>
  <div>
    <div
      v-for="(setParams, setIndex) in sets"
      :key="'set'+setIndex"
      class="align-center mb-2"
    >
      <div
        class="grey--text text--darken-1 d-inline-block"
        style="width: 60px"
        :class="{ 'caption': dense, 'text-body-1': !dense }"
      >
        {{ $t("training_builder.configure.set", {set: setIndex + 1}) }}:
      </div>

      <exercise-param-label-helper
        :label="$t('reps.label')"
        :dense="dense"
        :param="setParams.NMRP"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.duration.title')"
        :dense="dense"
        :param="setParams.STDR"
        suffix="s"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text.input.rir.title')"
        :dense="dense"
        :param="setParams.RIR"
      />

      <exercise-param-label-helper
        :label="$t('training_builder.text_input.weight.title')"
        :dense="dense"
        :param="getWeight(setParams.WGHT)"
        :suffix="weightSuffix(user.organisation_settings.unit_system)"
      />

      <exercise-param-label-helper
        label="% of RM"
        :dense="dense"
        :param="setParams.PERRM"
        suffix="%"
      />

      <exercise-param-label-helper
        :label="$t('event_type.rest')"
        :dense="dense"
        :param="setParams.RSSTDR"
        suffix="s"
      />

      <exercise-param-label-helper
        v-if="setParams.FVCH === true || setParams.FVCH.def === true"
        :label="$t('training_builder.dropdown.fv.title')"
        :dense="dense"
        :param="setParams.FVCH"
        :force-value="$t('status.yes')"
      />

      <exercise-param-label-helper
        v-if="setParams.FVCH === false || setParams.FVCH.def === false"
        :label="$t('training_builder.dropdown.fv.title')"
        :dense="dense"
        :param="setParams.FVCH"
        :force-value="$t('status.no')"
      />

      <span v-if="setParams.CNTP && (setParams.CNTP.length > 0 || (setParams.CNTP.def && setParams.CNTP.def.length > 0))">
        <span
          v-for="contractionType in (setParams.CNTP.def || setParams.CNTP.real || setParams.CNTP)"
          :key="'cntp' + contractionType"
        >
          <exercise-param-label-helper
            v-if="contractionType === $t('training_builder.contraction_type.iso')"
            :label="`${$t('training_builder.dropdown.contraction_type.title')} ${contractionType}`"
            :dense="dense"
            :param="setParams.ISDR"
            suffix="s"
          />
          <exercise-param-label-helper
            v-else-if="contractionType === $t('training_builder.contraction_type.ex')"
            :label="`${$t('training_builder.dropdown.contraction_type.title')} ${contractionType}`"
            :dense="dense"
            :param="setParams.EXDR"
            suffix="s"
          />
          <exercise-param-label-helper
            v-else-if="contractionType === 'Con'"
            :label="`${$t('training_builder.dropdown.contraction_type.title')} ${contractionType}`"
            :dense="dense"
            :param="setParams.CNDR"
            suffix="s"
          />
          <exercise-param-label-helper
            v-else-if="contractionType === $t('training_builder.contraction_type.ssc')"
            :label="`${$t('training_builder.dropdown.contraction_type.title')} ${contractionType}`"
            :dense="dense"
            :param="setParams.SSCDR"
            suffix="s"
          />
        </span>
      </span>
    </div>
  </div>
</template>
<script>

import ExerciseParamLabelHelper from '@/components/training-builder/ExerciseParamLabelHelper.vue'
import { convertWeightByTimezone, weightSuffix } from '@/components/training-builder/helpers'

export default {
  name: 'StrengthParamsView',
  components: { ExerciseParamLabelHelper },
  props: {
    sets: {
      type: Array,
      required: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    hasRealizations: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    }
  },
  methods: {
    weightSuffix,
    getWeight(param) {
      if (!param) return null

      if (!param.def) return convertWeightByTimezone(param, this.user.organisation_settings.unit_system, true)

      return {
        def: convertWeightByTimezone(param.def, this.user.organisation_settings.unit_system, true),
        real: convertWeightByTimezone(param.real, this.user.organisation_settings.unit_system, true)
      }
    }
  }
}
</script>
